module.exports = __webpack_public_path__ + "media/images/slider_img_sp_04-b9de651441ebc8e8cd1cc02d90287ebe.png";